import {
  FETCH_VEHICLES_DOCUMENTS_DATA,
  FETCH_VEHICLES_DOCUMENTS_SUCCESS,
  FETCH_VEHICLES_DOCUMENTS_FAILURE,
} from "./actionTypes";

/**
 * @param {Object|string|number} params - Options object, or driverId only (backward compat)
 * @param {number} [params.page=1] - Page number (1-based)
 * @param {number} [params.limit=10] - Items per page
 * @param {string|number} [params.driverId] - Optional filter by driver ID
 * @param {string|number} [params.vehicleCategoryId] - Optional filter by vehicle category ID
 */
export const fetchVehiclesDocumentsData = (params = {}) => {
  const isDriverIdOnly = typeof params === 'string' || typeof params === 'number';
  return {
    type: FETCH_VEHICLES_DOCUMENTS_DATA,
    payload: isDriverIdOnly
      ? { driverId: params, page: 1, limit: 10 }
      : {
          page: params.page ?? 1,
          limit: params.limit ?? 10,
          driverId: params.driverId,
          vehicleCategoryId: params.vehicleCategoryId,
        },
  };
};

export const fetchVehiclesDocumentsSuccess = (data) => ({
  type: FETCH_VEHICLES_DOCUMENTS_SUCCESS,
  payload: data,
});

export const fetchVehiclesDocumentsFailure = (error) => ({
  type: FETCH_VEHICLES_DOCUMENTS_FAILURE,
  payload: error,
});
